const PREFIX = 'language';

export class SetLanguage {
  static readonly type = PREFIX + '.SetLanguage';
  constructor(public language: string) {
  }
}
